import { use_slice_generation, use_slice_ml_asset } from '@/hooks/store/use_slices';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO_REQUEST__generation_create_for_field_consumer } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create_for_field_consumer';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useMemo } from 'react';

export function HOOK_REQUEST_FOR_FIELD_CONSUMER__create(field_consumer: FIELD__image_asset, generation_tool: DTO__generation_tool) {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { ml_assets_map } = use_slice_ml_asset(['ml_assets_map']);

  const image_asset = useMemo(() => get_image_asset(), [field_consumer]);

  let out = useMemo(() => create_request(), [image_asset, generation_tool, field_consumer, generation_current]);

  function create_request() {
    if (generation_current.is_stub()) return DTO_REQUEST__generation_create_for_field_consumer.CREATE_STUB();
    if (generation_tool.is_stub()) return DTO_REQUEST__generation_create_for_field_consumer.CREATE_STUB();

    generation_tool = generation_tool.clone();

    let generation_id = ENUM__string_id_empty.OBJECT_ID;

    let { graph } = generation_tool;

    generation_tool.generation_id = generation_id;
    generation_tool.view__set_current_first();

    graph.values_ml_assets__fill(ml_assets_map.values().toArray());

    /*
     *
     */
    graph.nodes__update_connected_to_grid2d();

    /*
     *
     */
    graph.set_graph_id(generation_id);
    graph.hash_clear();

    /*
     *
     */

    let request = new DTO_REQUEST__generation_create_for_field_consumer();
    request.generation_id_previous = field_consumer.meta.graph_id;
    request.tool = generation_tool;

    request.field_consumer = field_consumer;
    request.user_task_id = generation_current.user_task_id;

    generation_current.tool.graph.fields_store__save_to(request.fields_store);

    graph.fields__prepare();

    graph.nodes__prepare();

    graph.output_type__update();

    generation_tool.update_id();

    return request;
  }

  function get_image_asset() {
    let out = DTO__image_asset.CREATE_STUB();

    if (field_consumer.is_stub()) return out;
    if (!field_consumer.image__is_initialized) return out;
    if (field_consumer.hash_sha256_content.is_empty_hash_sha256()) return out;

    out = field_consumer.asset;

    return out;
  }

  return out;
}
